module.exports = __webpack_public_path__ + "media/images/ic_inbox-fed16a8637cfd4401cf689c1d02b5afe.svg";